"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _useValidationGroup2 = _interopRequireDefault(require("./hooks/useValidationGroup"));

var _useDeepState3 = _interopRequireDefault(require("./hooks/useDeepState"));

var _DataContext = _interopRequireDefault(require("./contexts/DataContext"));

var _HelpersContext = _interopRequireDefault(require("./contexts/HelpersContext"));

var _AddValidatorContext = _interopRequireDefault(require("./contexts/AddValidatorContext"));

var _useCallbackList3 = _interopRequireDefault(require("./hooks/useCallbackList"));

var _AddReducerContext = _interopRequireDefault(require("./contexts/AddReducerContext"));

var _IsSubmittingContext = _interopRequireDefault(require("./contexts/IsSubmittingContext"));

var Form = function Form(_ref) {
  var children = _ref.children,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
      initialData = _ref.initialData,
      isSubmitting = _ref.isSubmitting,
      _ref$as = _ref.as,
      Form = _ref$as === void 0 ? 'form' : _ref$as;

  var _useCallbackList = (0, _useCallbackList3["default"])(),
      _useCallbackList2 = (0, _slicedToArray2["default"])(_useCallbackList, 2),
      reducers = _useCallbackList2[0],
      addReducer = _useCallbackList2[1];

  var _useDeepState = (0, _useDeepState3["default"])(initialData, reducers),
      _useDeepState2 = (0, _slicedToArray2["default"])(_useDeepState, 3),
      data = _useDeepState2[0],
      setFieldValue = _useDeepState2[1],
      reset = _useDeepState2[2];

  var _useValidationGroup = (0, _useValidationGroup2["default"])(),
      addValidator = _useValidationGroup.addValidator,
      validate = _useValidationGroup.validate;

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    if (validate()) onSubmit(data);
    return false;
  };

  return /*#__PURE__*/_react["default"].createElement(_IsSubmittingContext["default"].Provider, {
    value: isSubmitting
  }, /*#__PURE__*/_react["default"].createElement(_DataContext["default"].Provider, {
    value: data
  }, /*#__PURE__*/_react["default"].createElement(_HelpersContext["default"].Provider, {
    value: {
      setFieldValue: setFieldValue,
      reset: reset
    }
  }, /*#__PURE__*/_react["default"].createElement(_AddValidatorContext["default"].Provider, {
    value: addValidator
  }, /*#__PURE__*/_react["default"].createElement(_AddReducerContext["default"].Provider, {
    value: addReducer
  }, /*#__PURE__*/_react["default"].createElement(Form, {
    onSubmit: handleSubmit
  }, typeof children === 'function' ? children(data) : children))))));
};

var _default = Form;
exports["default"] = _default;